module.exports = __webpack_public_path__ + "static/gorgaslibrary01_1920-cde86cc8536c61a3368a157cf85415d0.jpg";